import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {Owner} from "../../model/customer/owner";
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {MoneyOwner} from "../../model/customer/money-owner";
import {BrokerageTable} from "../../model/customer/brokerage-table";

@Injectable({
  providedIn: 'root'
})
export class CustomerBrokerageTableService extends CommonCrudService<BrokerageTable> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_BROKERAGE_TABLE_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_BROKERAGE_TABLE,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_BROKERAGE_TABLE);
  }

}
